import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { useAnalytics } from '@gjl/analytics'
import { Header } from './Header'
import { Footer } from './Footer'
import { AskGarrettAI } from './AskGarrettAI'
import { useLenis } from '@/hooks'

export function Layout() {
  const analytics = useAnalytics()
  const { pathname, search } = useLocation()

  useEffect(() => {
    analytics.page(document.title, { path: pathname + search })
  }, [analytics, pathname, search])

  // Initialize smooth scrolling
  useLenis()

  return (
    <div className="bg-background text-foreground flex min-h-screen flex-col">
      <Header />
      {/* Add padding for fixed header */}
      <main className="flex-1 pt-16 md:pt-20">
        <Outlet />
      </main>
      <Footer />
      {/* Grounded-assistant demo — floating retrieval widget on every page */}
      <AskGarrettAI />
    </div>
  )
}
